import { useMemo } from 'react';
import { useRouteHook } from '@shared/hooks';
import { AmountUtils, FormatUtils, RoutePaths } from '@shared/utils';
import { type AccountResponse, AccountType } from '@shared/api/rest/accounts';
import { Table, TableCellType } from '@shared/widgets';

const accountCardTableColumns = ['account', 'currency', 'product', 'status', 'limit', 'balance'];
const accountPaymentTableColumns = ['account name', 'product', 'account', 'currency', 'iban', 'status', 'balance'];

interface Props {
  isLoading?: boolean;
  accountType: AccountType;
  accounts: AccountResponse[];
}

export const AccountsTable = (props: Props) => {
  const { navigate } = useRouteHook();

  const data = useMemo(() => props.accounts.filter((x) => x.type == props.accountType), [props.accounts, props.accountType]);

  if (props.accountType === AccountType.Card)
    return (
      <Table
        isLoading={props.isLoading}
        isScrollable
        columns={accountCardTableColumns}
        items={data.map((x) => [
          { type: TableCellType.Text, value: x.accountNumber },
          { type: TableCellType.Text, value: x.currency },
          { type: TableCellType.Text, value: x.productName },
          { type: TableCellType.Text, value: x.status.toUpperCase() },
          { type: TableCellType.Text, value: AmountUtils.transformToAmountWithCurrency(x.creditLimit ?? 0, x.currency) },
          { type: TableCellType.Text, value: AmountUtils.transformToAmountWithCurrency(x.balance ?? 0, x.currency) },
        ])}
        onClick={(rowIndex) => {
          const accountId = data.find((_, index) => rowIndex === index)?.id;
          navigate(RoutePaths.account.onNavigate(accountId!));
        }}
      />
    );
  return (
    <Table
      isLoading={props.isLoading}
      isScrollable
      columns={accountPaymentTableColumns}
      items={data.map((x) => [
        { type: TableCellType.Text, value: x.name || FormatUtils.formatAccountNumber(x.accountNumber) },
        { type: TableCellType.Text, value: x.productName },
        { type: TableCellType.Text, value: x.accountNumber },
        { type: TableCellType.Text, value: x.currency },
        { type: TableCellType.Text, value: x.iban },
        { type: TableCellType.Text, value: x.status.toUpperCase() },
        { type: TableCellType.Text, value: AmountUtils.transformToAmountWithCurrency(x.availableBalance ?? 0, x.currency) },
      ])}
      onClick={(rowIndex) => {
        const accountId = data.find((_, index) => rowIndex === index)?.id;
        navigate(RoutePaths.account.onNavigate(accountId!));
      }}
    />
  );
};
